import { Recipient } from '@bonusly/recipient-entities';

import { Privacy } from '../../components/privacy/types';
import { Attachment } from './attachment';

interface ActionDataValues {
	attachment: Attachment | null;
	amount: number | null;
	flashPointsUsed: boolean;
	hashtags: string[];
	hasAmount: boolean;
	hasHashtag: boolean;
	hasRecipient: boolean;
	includeGiver: boolean;
	mentions: Recipient[];
	recipients: Recipient[];
	privacy: Privacy;
	text: string;
	totalAmount: number;
	recipientCount: number;
}

export class ActionData {
	public amount: number | null;
	public attachment: Attachment | null;
	public flashPointsUsed: boolean;
	public hasAmount: boolean;
	public hasHashtag: boolean;
	public hasRecipient: boolean;
	public hashtags: string[];
	public includeGiver: boolean;
	public mentions: Recipient[];
	public privacy: Privacy;
	public recipients: Recipient[];
	public text: string;
	public totalAmount: number;
	public recipientCount: number;
	constructor(data: ActionDataValues) {
		this.amount = data.amount;
		this.attachment = data.attachment;
		this.flashPointsUsed = data.flashPointsUsed;
		this.hasAmount = data.hasAmount;
		this.hasHashtag = data.hasHashtag;
		this.hasRecipient = data.hasRecipient;
		this.hashtags = data.hashtags;
		this.includeGiver = data.includeGiver;
		this.mentions = data.mentions;
		this.privacy = data.privacy;
		this.recipients = data.recipients;
		this.text = data.text;
		this.totalAmount = data.totalAmount;
		this.recipientCount = data.recipientCount;
	}
}
